import { makeStyles } from '@mui/styles'
import { PropsWithChildren } from 'react'

const contentMaxWidth = 1366

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    maxWidth: contentMaxWidth,
    paddingY: '1.25rem',
    paddingX: 0,
    margin: 0,
    marginTop: '1rem',
  },
})

const Page = ({ children }: PropsWithChildren) => {
  const classes = useStyles()

  return <div className={classes.root}>{children}</div>
}

export default Page
